const body = document.querySelector(`body`);
const watchBtns = document.querySelectorAll(`.popup__watch-video`);
const getStartedBtn = document.querySelector(`.popup__get-started`);
const overlayFragment = document.createDocumentFragment();
const overlay = document.createElement(`div`);
overlay.classList.add(`overlay`);
overlay.style.overflow = `auto`;

const popup = document.createElement(`div`);
popup.classList.add(`popup`);

const createVideoPopup = (fragment) => {
  popup.classList.add(`popup--video`);
  popup.innerHTML = `
  <svg class="popup__close" width="30" height="30">
    <use xlink:href="./passhub.net/img/sprite.svg#icon-close"></use>
  </svg>
  <div class="popup__wrapper popup__wrapper--video">
    <iframe class="popup__video" src="https://www.youtube-nocookie.com/embed/EaBA45c3yC4?controls=1" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
  `;
  fragment.appendChild(popup);
}

const createGetStartedPopup = (fragment) => {
  popup.classList.add(`popup--getstarted`);
  popup.innerHTML = `
  <svg class="popup__close" width="30" height="30">
    <use xlink:href="./passhub.net/img/sprite.svg#icon-close"></use>
  </svg>
  <div class="popup__wrapper popup__wrapper--getstarted">
    <div class="page-content__wrapper getstarted">
      <h2 class="heading heading--h2 heading--center heading--uppercase heading--margin-top-big">Get started in 60 seconds</h2>
      <ol class="getstarted__list">
        <li class="getstarted__item getstarted__item--first">
          <p class="text text--center text--grey">
            Install and open the WWPass PassKey app
          </p>
          <div class="getstarted__store">
            <a href="https://itunes.apple.com/us/app/wwpass-passkey-lite/id984532938" class="button button--store button--store-apple"></a>
            <a href="https://play.google.com/store/apps/details?id=com.wwpass.android.passkey" class="button button--store button--store-google"></a>
          </div>
          <img src="passhub.net/img/icon-getstarted-start.svg" class="img img--getstarted">
        </li>
        <li class="getstarted__item getstarted__item--second">
          <div class="getstarted__device">
            <img src="passhub.net/img/icon-getstarted-desktop.svg" class="img img--getstarted">
            <h3 class="heading heading--h3 heading--center heading--margin-bottom-0">Desktop</h3>
            <p class="text text--sm text--grey text--center">
              Go to PassHub.net<br>and scan the QR-code
            </p>
          </div>
          <div class="getstarted__device">
            <img src="passhub.net/img/icon-getstarted-mobile.svg" class="img img--getstarted">
            <h3 class="heading heading--h3 heading--center heading--margin-bottom-0">Mobile</h3>
            <p class="text text--sm text--grey text--center">
              Go to PassHub.net and<br>tap the QR-code
            </p>
          </div>
        </li>
        <li class="getstarted__item getstarted__item--third">
          <div class="getstarted__device">
            <img src="passhub.net/img/icon-getstarted-finish.svg" class="img img--getstarted">
            <h3 class="heading heading--h3 heading--center heading--margin-bottom-0">Congrats!</h3>
            <p class="text text--sm text--grey text--center">
                Your free PassHub account is ready
            </p>
            </div>
        </li>
      </ol>
    </div>
  </div>
  `;
  fragment.appendChild(popup);
}

const openVideo = () => {
  createVideoPopup(overlay);
  overlayFragment.appendChild(overlay);
  body.appendChild(overlayFragment);
  body.style.overflow = `hidden`;
};

const openGetStarted = () => {
  createGetStartedPopup(overlay);
  overlayFragment.appendChild(overlay);
  body.appendChild(overlayFragment);
  body.style.overflow = `hidden`;
};

const closePopup = (evt) => {
  if (evt.target !== overlay) {
    return;
  } else {
    overlay.remove();
    popup.remove();
    popup.classList = `popup`;
    body.style.overflow = `auto`;
  }
};

watchBtns.forEach(btn => {
  btn.addEventListener(`click`, (evt) => {
    evt.preventDefault();
    openVideo();
  
    overlay.addEventListener(`click`, closePopup);
  });
})

if (getStartedBtn) {
  getStartedBtn.addEventListener(`click`, (evt) => {
    evt.preventDefault();
    openGetStarted();
  
    overlay.addEventListener(`click`, closePopup);
  });
}

